import { useKioskAeropayUser, useKioskUser } from '@jane/kiosk/data-access';

export const useKioskJaneGoldData = () => {
  const { data: userData, isFetching: userIsFetching } = useKioskUser();
  const { data: aeropayUserData, isFetching: aeropayUserIsFetching } =
    useKioskAeropayUser({
      janeUserId: userData?.id,
    });

  const bankAccounts = aeropayUserData?.bank_accounts || [];
  const selectedBankAccount = bankAccounts?.find(
    (bankAccount) => bankAccount.is_selected === true
  );
  const userHasLinkedBank = bankAccounts && bankAccounts.length > 0;

  const userSignedIn = !!userData?.id;

  const isLoading = userIsFetching || aeropayUserIsFetching;

  return {
    userData,
    aeropayUserData,
    userSignedIn,
    isLoading,
    selectedBankAccount,
    userHasLinkedBank,
  };
};
